import { makeStyles } from '@material-ui/core';

export const useStyle = makeStyles(() => ({
  cardRoot: {
    paddingTop: 20,
    paddingBottom: 15,
    paddingLeft: 30,
    paddingRight: 30,
    borderRadius: 10,
    boxShadow: '0px 2px 15px rgba(0, 0, 0, 0.08)',
  },
  container: {
    marginTop: 25,
  },
  titleText: {
    fontSize: 19,
    fontWeight: 900,
  },
  titleSection: { paddingBottom: 7, marginBottom: 20 },
  logo: { marginRight: 11 },
}));

export default useStyle;
